module.exports = __webpack_public_path__ + "img/home.d5cd8f66.svg";